export const FETCH_LAST_COMPETITIONS_REQUEST = 'FETCH_LAST_COMPETITIONS_REQUEST'
export const FETCH_LAST_COMPETITIONS_SUCCESS = 'FETCH_LAST_COMPETITIONS_SUCCESS'
export const FETCH_LAST_COMPETITIONS_FAILED = 'FETCH_LAST_COMPETITIONS_FAILED'

export const FETCH_SAVE_ADDITIONAL_DANCERS_INFO_REQUEST = 'FETCH_SAVE_ADDITIONAL_DANCERS_INFO_REQUEST'
export const FETCH_SAVE_ADDITIONAL_DANCERS_INFO_SUCCESS = 'FETCH_SAVE_ADDITIONAL_DANCERS_INFO_SUCCESS'
export const FETCH_SAVE_ADDITIONAL_DANCERS_INFO_FAILED = 'FETCH_SAVE_ADDITIONAL_DANCERS_INFO_FAILED'



// WEBPACK FOOTER //
// ./src/modules/Dashboard/consts/additionalDancersInfoConsts.js